import * as React from "react";
import { FilterLiveSearch, useTranslate } from 'react-admin';

export default (props) => {
    const t = useTranslate();

    return (
        <FilterLiveSearch source="globalUserId" label={t('components.list_filters.globalUserId', { _: 'Global user ID' })} />
    )
};